import { bizRequest } from '@/common/service/ApiList';
import {updateToast, insertToast, removeToast, customToast} from '@/common/utils/ToastServiceResult';
import { assist } from '@/common/utils/ParameterAssistant';

import ServiceExec from '@/common/utils/ServiceExec';

const { getList, detail, save} = bizRequest;

const actions = {
  FETCH_LIST: async ({ commit, state }, page) => {
    const { condition } = state;
    commit('setCondition', assist(condition, page));

    const { status, data } = await ServiceExec.get(getList, condition);
    if (status === 200) {
      const { list, pageInfo } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo ?? {});
    }
  },
  FETCH_DETAIL: async ({ commit, state }, bizRequestNo) => {
    const { status, data } = await ServiceExec.get(detail(bizRequestNo));
    if (status === 200) commit('setDetail', data);

    commit('setDetail', data)
  },
  SAVE: async ({commit, state}, form ) => {
    const {status, data} = await ServiceExec.post(save, form)
    if(customToast(status, data, "요청을 완료했습니다.")) return true
    else return false
  }
};
export default actions;

